import { z } from 'zod';

const baseUserSchema = z.object({
    full_name: z.string().min(2, 'Full name is too short'),
    username: z.string().min(3, 'Username must be at least 3 characters').regex(/^[^@]+$/, "Username cannot contain '@'"),
    profile_url: z.string().url('Invalid URL').optional().nullable(),
});

export const studentSchema = baseUserSchema.extend({
    role: z.literal('student'),
    password: z.string().min(6, 'Password must be at least 6 characters'),
    grade: z.string().min(1, 'Grade is required'),
    section: z.string().min(1, 'Section is required'),
});

export const teacherSchema = baseUserSchema.extend({
    role: z.literal('teacher'),
    password: z.string().min(6, 'Password must be at least 6 characters'),
});

// For editing - Only full_name, grade, and section are allowed to be updated
export const updateStudentSchema = z.object({
    full_name: z.string().min(2, 'Name is too short'),
    grade: z.string().min(1, 'Grade is required'),
    section: z.string().min(1, 'Section is required'),
    profile_url: z.string().url('Invalid URL').optional().nullable(),
});

export const updateTeacherSchema = z.object({
    full_name: z.string().min(2, 'Name is too short'),
    profile_url: z.string().url('Invalid URL').optional().nullable(),
});

// Discriminated union for cases where we handle both in one creation form
export const addUserSchema = z.discriminatedUnion('role', [
    studentSchema,
    teacherSchema
]);

export type StudentFormValues = z.infer<typeof studentSchema>;
export type TeacherFormValues = z.infer<typeof teacherSchema>;
export type UpdateStudentFormValues = z.infer<typeof updateStudentSchema>;
export type UpdateTeacherFormValues = z.infer<typeof updateTeacherSchema>;
export type AddUserFormValues = z.infer<typeof addUserSchema>;
